import { Pipe, PipeTransform } from '@angular/core'
import moment from 'moment'

@Pipe({
  name: 'momentp',
  standalone: true,
})
export class MomentPipe implements PipeTransform {
  transform(value: string | Date | moment.Moment | undefined, dateFormat = 'LT'): string {
    if (value) {
      return moment(value).format(dateFormat)
    } else return ''
  }
}
